(() => {
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  const dotsSeen = new WeakSet();
  const guide = document.getElementById('EBSizeGuide');
  const bar = document.getElementById('EBMobileBuy');
  let guideTrigger;
  let frame;
  let watchedMain;
  const mainObserver = new MutationObserver(schedule);
  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = null; scan(); syncBuy(); });
  }
  function setupDots(component) {
    if (dotsSeen.has(component)) return;
    const counter = component.querySelector('.slider-counter');
    const total = component.querySelector('.slider-counter--total');
    const current = component.querySelector('.slider-counter--current');
    if (!counter || !total || !current || !component.slider) return;
    dotsSeen.add(component);
    const dots = document.createElement('div');
    dots.className = 'eb-slider-dots';
    dots.setAttribute('role', 'group');
    dots.setAttribute('aria-label', 'Navigation du carrousel');
    counter.append(dots);
    function refresh() {
      const count = Number(total.textContent);
      const active = Number(current.textContent);
      if (!Number.isInteger(count) || count < 2) {
        counter.classList.remove('eb-counter-with-dots');
        dots.hidden = true;
        return;
      }
      counter.classList.add('eb-counter-with-dots');
      dots.hidden = false;
      if (dots.children.length !== count) {
        dots.replaceChildren();
        for (let i = 0; i < count; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'eb-slider-dot';
          dot.setAttribute('aria-label', `Aller à la page ${i + 1} du carrousel`);
          dot.addEventListener('click', () => {
            component.slider.scrollTo({ left: i * component.sliderItemOffset, behavior: motion() });
          });
          dots.append(dot);
        }
      }
      [...dots.children].forEach((dot, i) => {
        const value = String(i + 1 === active);
        if (dot.getAttribute('aria-current') !== value) dot.setAttribute('aria-current', value);
      });
    }
    component.addEventListener('slideChanged', refresh);
    const observer = new MutationObserver(refresh);
    observer.observe(total, { childList: true, characterData: true, subtree: true });
    observer.observe(current, { childList: true, characterData: true, subtree: true });
    refresh();
  }
  function scan() {
    document.querySelectorAll('slider-component').forEach(setupDots);
    const main = document.querySelector('product-info[id^="MainProduct-"]');
    if (main && main !== watchedMain) {
      watchedMain = main;
      mainObserver.disconnect();
      mainObserver.observe(main, { subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class'], childList: true, characterData: true });
    }
    if (!main || !guide || main.querySelector('[data-eb-size-guide-open]')) return;
    const picker = main.querySelector('variant-selects');
    if (!picker) return;
    const option = [...picker.querySelectorAll('fieldset, .product-form__input--dropdown')].find(el => /taille|size|pointure/i.test(el.querySelector('.form__label')?.textContent || ''));
    if (!option) return;
    const button = document.getElementById('EBSizeGuideButton').content.firstElementChild.cloneNode(true);
    option.after(button);
    button.addEventListener('click', () => { guideTrigger = button; guide.showModal(); });
  }
  function syncBuy() {
    if (!bar) return;
    const main = document.querySelector('product-info[id^="MainProduct-"]');
    const original = main?.querySelector('.product-form__submit');
    const target = bar.querySelector('[data-eb-buy-button]');
    const price = bar.querySelector('[data-eb-buy-price]');
    if (!original) { bar.hidden = true; document.body.classList.remove('eb-mobile-buy-visible'); return; }
    const label = original.querySelector('span')?.textContent.trim() || 'Ajouter au panier';
    if (target.textContent !== label) target.textContent = label;
    target.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true' || original.classList.contains('loading');
    const priceBox = main.querySelector('.price');
    const amount = priceBox?.querySelector(priceBox.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular')?.textContent.trim() || '';
    if (price.textContent !== amount) price.textContent = amount;
    const visible = matchMedia('(max-width: 749px)').matches && original.getBoundingClientRect().bottom < 0 && main.getBoundingClientRect().bottom > 0 && !document.querySelector('dialog[open], cart-drawer.active, .quick-add-modal[open]');
    bar.hidden = !visible;
    document.body.classList.toggle('eb-mobile-buy-visible', visible);
  }
  guide?.querySelector('[data-eb-size-guide-close]').addEventListener('click', () => guide.close());
  guide?.addEventListener('click', event => {
    if (event.target !== guide) return;
    const rect = guide.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) guide.close();
  });
  guide?.addEventListener('close', () => { guideTrigger?.focus(); schedule(); });
  bar?.querySelector('[data-eb-buy-button]').addEventListener('click', () => {
    const original = document.querySelector('product-info[id^="MainProduct-"] .product-form__submit');
    if (original && !original.disabled && original.getAttribute('aria-disabled') !== 'true' && !original.classList.contains('loading')) original.click();
  });
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });
  customElements.whenDefined('slider-component').then(schedule);
  document.addEventListener('shopify:section:load', schedule);
  scan();
  syncBuy();
})();